import React from "react"
import { ProductColor } from "./ProductColor"

const ProductColors = ({ product, onClick, size }: any) => (
  <div style={{ display: "flex", width: 100, flexWrap: "wrap", gap: 2 }}>
    {product.skus.map((sku: any, index: number) => (
      <ProductColor key={index} sku={sku} onClick={onClick} size={size} />
    ))}
  </div>
)

export default ProductColors
